import { useMemo } from 'react';
import { Button, Row } from '@tempmee/react';
import { InfoSection } from './components/InfoSection';
import { formatExpectedDays } from './utils/formatters';
import { IEditableFormProps } from './Types';
import { ScheduleForm, SchedulePreview } from './components/ScheduleInfo';

export const ScheduleEditable = ({
  jobPosting,
  editMode,
  hideEditButton,
  disableSave,
  control,
  errors,
  onEditClick,
  onCancelClick,
  onSaveClick,
}: IEditableFormProps) => {
  const { scheduleType, expectedDays } = jobPosting || {};

  const expectedDaysDisplay = useMemo(() => formatExpectedDays(expectedDays || []), [expectedDays]);

  if (editMode) {
    return (
      <InfoSection
        icon="calendar-solid"
        title="Schedule"
        rightAction={
          <Row gap={3}>
            <Button variant="outlined" size="xs" onClick={onCancelClick}>
              Cancel
            </Button>
            <Button disabled={disableSave} size="xs" onClick={onSaveClick}>
              Save
            </Button>
          </Row>
        }
      >
        <ScheduleForm control={control} errors={errors} />
      </InfoSection>
    );
  }

  return (
    <InfoSection
      icon="calendar-solid"
      title="Schedule"
      rightActionIcon="edit-pencil"
      onRightActionPress={hideEditButton ? undefined : onEditClick}
    >
      <SchedulePreview scheduleType={scheduleType || ''} expectedDays={expectedDaysDisplay} />
    </InfoSection>
  );
};
